export const GRAY_200 = "#E5E5E5";
export const GRAY_300 = "#F8F8F8";
export const GRAY_320 = "#F3F3F3";
export const GRAY_400 = "#A7A7A7";
export const GRAY_450 = "#989898";
export const GRAY_500 = "#757575";
export const GRAY_550 = "#616161";
export const GRAY_900 = "#312E2E";

export const RED_500 = "#f44336";

export const BLUE_300 = "#5D8DEA";

export const GREEN_500 = "#1CEE96";
export const GREEN_700 = "#00c853";

export const YELLOW_500 = "#FFC34F";

export const ORANGE_500 = "#E48E62";
export const ORANGE_600 = "#BE5A61";

export const BLACK = "#272727";
export const WHITE = "#ffffff";
